import classes from '../data/classes';

const getTagsFromRules = (rules) => {
  const tags = [];
  rules.forEach((rule) => {
    if (rule.excludeSkillsWithTags.length > 0) {
      rule.excludeSkillsWithTags.forEach((tag) => {
        if (tags.indexOf(tag) < 0) {
          tags.push(tag);
        }
      });
    }
  });
  return tags;
};

const getSkillsWithTagsForPlayedClass = (playedClass, tags) => {
  const excludedSkills = [];
  const includedSkills = [];
  classes[playedClass].skills.forEach((skill) => {
    const excludedRunes = [];
    const includedRunes = [];
    skill.runes.forEach((rune) => {
      tags.forEach((tag) => {
        if (rune.tags.indexOf(tag) >= 0 && excludedRunes.indexOf(rune) < 0) {
          excludedRunes.push(rune);
        }
      });
    });
    if (excludedRunes.length > 0) {
      excludedSkills.push({
        name: skill.name,
        runes: excludedRunes,
      });
    }
    skill.runes.forEach((rune) => {
      if (excludedRunes.indexOf(rune) < 0) {
        includedRunes.push(rune);
      }
    });
    if (includedRunes.length > 0) {
      includedSkills.push({
        name: skill.name,
        runes: includedRunes,
      });
    }
  });
  const excludedPassives = [];
  const includedPassives = [];
  classes[playedClass].passives.forEach((passive) => {
    tags.forEach((tag) => {
      if (
        passive.tags.indexOf(tag) >= 0 &&
        excludedPassives.indexOf(passive) < 0
      ) {
        excludedPassives.push(passive);
      } else if (includedPassives.indexOf(passive) < 0) {
        includedPassives.push(passive);
      }
    });
  });

  return {
    excludedSkills,
    includedSkills,
    excludedPassives,
    includedPassives,
  };
};

const mapExcludedSKillsFromRules = (rules, playedClass) => {
  const tags = getTagsFromRules(rules);
  const skills = getSkillsWithTagsForPlayedClass(playedClass, tags);

  return skills;
};

export default mapExcludedSKillsFromRules;
